/*
 * @Descripttion: 
 * @Author: panyufeng
 * @Date: 2025-03-31 11:43:58
 * @LastEditors: panyufeng
 * @LastEditTime: 2025-04-02 14:43:31
 */
import service from '@/utils/request'

// 列表
export const getList = (params: any) =>
  service.request({
    method: 'post',
    url: 'operation/violation/page',
    data: params
  })

// 下拉框
export const gabCarQuery = (params: any) =>
  service.request({
    method: 'post',
    url: 'operation/gabCar/query',
    data: params
  })

// 资产公司
export const enterpriseViolationSettingQuery = (params: any) =>
  service.request({
    method: 'post',
    url: '/enterpriseViolationSetting/query',
    data: params
  })
